import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from './auction.svg'
import _imports_1 from './shop.svg'


import { computed } from "vue";
import labels from "../../../controls/shared/labels";

export default /*@__PURE__*/_defineComponent({
  __name: 'image-overlay-item',
  props: {
    type: String,
    link: String,
},
  setup(__props) {

const props = __props;

const linkHref = computed(() => {
    if (props.link == null || props.link == "") {
        return undefined;
    }
    return props.link;
});

const tag = computed(() => {
    if (linkHref.value == null) {
        return "div";
    }
    return "a";
});

const tagStyle = computed(() => {
    if (linkHref.value != null) {
        return {
            cursor: "pointer",
            "pointer-events": "all",
        };
    }
    return undefined;
});

return (_ctx: any,_cache: any) => {
  return (__props.type === 'third-party-stamp')
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), {
        key: 0,
        href: linkHref.value,
        style: _normalizeStyle(tagStyle.value),
        class: "product-sponsor-third-party-bar"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage.overlay.thirdPartyText), 1 /* TEXT */)
        ], undefined, true),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["href", "style"]))
    : (__props.type === 'related-auction')
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), {
          key: 1,
          href: linkHref.value,
          style: _normalizeStyle(tagStyle.value),
          class: "product-with-related-auction-bar"
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: _imports_0,
              "data-no-block": "",
              width: "19.5",
              height: "19.5",
              style: {"height":"1em","scale":"1.5","margin-right":"2px"}
            }, null, -1 /* HOISTED */)),
            _createTextVNode(" " + _toDisplayString(_unref(labels).frontendProductpage.overlay.relatedAuctionText), 1 /* TEXT */)
          ], undefined, true),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href", "style"]))
      : (__props.type === 'related-shop')
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), {
            key: 2,
            href: linkHref.value,
            style: _normalizeStyle(tagStyle.value),
            class: "product-with-related-auction-bar"
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: _imports_1,
                "data-no-block": "",
                width: "19.5",
                height: "19.5",
                style: {"height":"1em","scale":"1.5","margin-right":"2px"}
              }, null, -1 /* HOISTED */)),
              _createTextVNode(" " + _toDisplayString(_unref(labels).frontendProductpage.overlay.relatedShopText), 1 /* TEXT */)
            ], undefined, true),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href", "style"]))
        : (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), {
            key: 3,
            href: linkHref.value,
            style: _normalizeStyle(tagStyle.value),
            class: _normalizeClass(['product-image-overlay', __props.type])
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ], undefined, true),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["href", "style", "class"]))
}
}

})